// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" fill=\"black\" viewBox=\"0 0 16 16\"%3E%3Cpath d=\"M11.354 1.646a.5.5 0 0 1 0 .708L6.707 7l4.647 4.646a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0z\"/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" fill=\"black\" viewBox=\"0 0 16 16\"%3E%3Cpath d=\"M4.646 1.646a.5.5 0 0 1 .708 0l5 5a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708-.708L9.293 8 4.646 3.354a.5.5 0 0 1 0-.708z\"/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homework-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

.history-toggle {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.history-toggle input {
  margin-right: 10px;
}

.homework-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.day-card {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.day-title {
  color: #333;
  margin: 0 0 15px;
}

.subjects {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.subject-card {
  background-color: #e3f2fd;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.subject-title {
  color: #1976d2;
  margin: 0 0 10px;
}

.homework-item {
  margin: 5px 0;
  color: #555;
}

.homework-item::before {
  content: '📖'; /* Optional: Add a book emoji before each homework item */
  margin-right: 5px;
}

  
  /* #historyToggle + label {
    display: inline-block;
    margin: 10px 0;
    cursor: pointer;
  } */
  .zoomed-image {
    transition: transform 0.2s ease-in-out;
  }

  .coming-soon-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: #f0f0f0;
    text-align: center;
  }
  
  .title {
    font-size: 3rem;
    margin-bottom: 20px;
    color: #333;
  }
  
  .message {
    font-size: 1.2rem;
    margin-bottom: 40px;
    color: #555;
  }
  
  .countdown {
    font-size: 2rem;
    font-weight: bold;
    color: #ff6347;
  }
  
  .countdown span {
    display: inline-block;
    min-width: 40px;
  }

  
/* .calendar-container {
  max-width: 600px;
  margin: 20px auto;
  text-align: center;
}

.date-picker-container {
  margin-bottom: 20px;
}

.custom-date-picker {
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.attendance-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.attendance-table th, .attendance-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  font-size: 16px;
}

.status-present {
  background-color: #4CAF50; 
  color: white;
}

.status-absent {
  background-color: #FF5252; 
  color: white;
}

.status-holiday {
  background-color: #FFEB3B; 
  color: black;
} */

/* AttendanceDashboard.css */
/* AttendanceDashboard.css */
.attendance-dashboard {
  max-width: 800px;
  margin: 20px auto;
  text-align: center;
}

.date-picker-container {
  margin-bottom: 20px;
}

.custom-date-picker {
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.calendar {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  margin-bottom: 20px;
}

.calendar-day {
  padding: 20px;
  border: 1px solid #ddd;
  font-weight: bold;
  color: #333;
  border-radius: 5px;
}

.status-present {
  background-color: #4CAF50; /* Green for Present */
  color: white;
}

.status-absent {
  background-color: #FF5252; /* Red for Absent */
  color: white;
}

.status-holiday {
  background-color: #FFEB3B; /* Yellow for Holiday */
  color: black;
}

.attendance-table {
  width: 100%;
  border-collapse: collapse;
}

.attendance-table th, .attendance-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.custom-carousel .carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-carousel .carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

`, "",{"version":3,"sources":["webpack://./src/views/dashboards/components/homework.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa,EAAE,yDAAyD;EACxE,iBAAiB;AACnB;;;EAGE;;;;KAIG;EACH;IACE,sCAAsC;EACxC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;;AAGF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2CG;;AAEH,4BAA4B;AAC5B,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;EACjD,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yDAAwQ;AAC1Q;;AAEA;EACE,yDAAwQ;AAC1Q","sourcesContent":[".homework-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: Arial, sans-serif;\n}\n\nh2 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.history-toggle {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.history-toggle input {\n  margin-right: 10px;\n}\n\n.homework-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.day-card {\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 15px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.day-title {\n  color: #333;\n  margin: 0 0 15px;\n}\n\n.subjects {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.subject-card {\n  background-color: #e3f2fd;\n  border-radius: 5px;\n  padding: 10px;\n  margin-bottom: 10px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.subject-title {\n  color: #1976d2;\n  margin: 0 0 10px;\n}\n\n.homework-item {\n  margin: 5px 0;\n  color: #555;\n}\n\n.homework-item::before {\n  content: '📖'; /* Optional: Add a book emoji before each homework item */\n  margin-right: 5px;\n}\n\n  \n  /* #historyToggle + label {\n    display: inline-block;\n    margin: 10px 0;\n    cursor: pointer;\n  } */\n  .zoomed-image {\n    transition: transform 0.2s ease-in-out;\n  }\n\n  .coming-soon-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    background-color: #f0f0f0;\n    text-align: center;\n  }\n  \n  .title {\n    font-size: 3rem;\n    margin-bottom: 20px;\n    color: #333;\n  }\n  \n  .message {\n    font-size: 1.2rem;\n    margin-bottom: 40px;\n    color: #555;\n  }\n  \n  .countdown {\n    font-size: 2rem;\n    font-weight: bold;\n    color: #ff6347;\n  }\n  \n  .countdown span {\n    display: inline-block;\n    min-width: 40px;\n  }\n\n  \n/* .calendar-container {\n  max-width: 600px;\n  margin: 20px auto;\n  text-align: center;\n}\n\n.date-picker-container {\n  margin-bottom: 20px;\n}\n\n.custom-date-picker {\n  padding: 8px;\n  font-size: 16px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.attendance-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n.attendance-table th, .attendance-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n  font-size: 16px;\n}\n\n.status-present {\n  background-color: #4CAF50; \n  color: white;\n}\n\n.status-absent {\n  background-color: #FF5252; \n  color: white;\n}\n\n.status-holiday {\n  background-color: #FFEB3B; \n  color: black;\n} */\n\n/* AttendanceDashboard.css */\n/* AttendanceDashboard.css */\n.attendance-dashboard {\n  max-width: 800px;\n  margin: 20px auto;\n  text-align: center;\n}\n\n.date-picker-container {\n  margin-bottom: 20px;\n}\n\n.custom-date-picker {\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n}\n\n.calendar {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.calendar-day {\n  padding: 20px;\n  border: 1px solid #ddd;\n  font-weight: bold;\n  color: #333;\n  border-radius: 5px;\n}\n\n.status-present {\n  background-color: #4CAF50; /* Green for Present */\n  color: white;\n}\n\n.status-absent {\n  background-color: #FF5252; /* Red for Absent */\n  color: white;\n}\n\n.status-holiday {\n  background-color: #FFEB3B; /* Yellow for Holiday */\n  color: black;\n}\n\n.attendance-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.attendance-table th, .attendance-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n}\n\n.custom-carousel .carousel-control-prev-icon {\n  background-image: url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" fill=\"black\" viewBox=\"0 0 16 16\"%3E%3Cpath d=\"M11.354 1.646a.5.5 0 0 1 0 .708L6.707 7l4.647 4.646a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0z\"/%3E%3C/svg%3E');\n}\n\n.custom-carousel .carousel-control-next-icon {\n  background-image: url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" fill=\"black\" viewBox=\"0 0 16 16\"%3E%3Cpath d=\"M4.646 1.646a.5.5 0 0 1 .708 0l5 5a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708-.708L9.293 8 4.646 3.354a.5.5 0 0 1 0-.708z\"/%3E%3C/svg%3E');\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
